import React, { useState } from 'react';
// import SocialLinks from './SocialMediaLink';
import MinusIcon from '../../images/minus.svg';
import PlusIcon from '../../assets/images/plus-icon-2.svg';
import Link from './Link';
import initialData from '../../initial-data';
import { useResume } from '../../context/ResumeContext';

const Portfolio = (props) => {

    const {resume:{ socials, portfolio },handlers:{updateResumePreview}} = useResume();

    let migrated = false;
    const savePortfolio = (portfolio) => {
        // props.handlers.updateResumePreview({ socials: sociallinks });
        updateResumePreview({ portfolio: { set: { ...portfolio } } });
        // dispatch(saveResume({ socials: sociallinks }, PREVIEW_RESUME));
      }
      
    //Code for backward compatibility
    if(portfolio == undefined &&  Object.values(socials).length){
        let collect;
        Object.keys(socials).map(k =>{
        let id = 'id_' + Math.floor(Math.random() * 1000);
        //Only add available options
        let ob = { [id]: { label:  socials[k].name, link: socials[k].link } }
        collect = {...collect, ...ob}
        })
        savePortfolio(collect)
        migrated = true
    }
    let links = portfolio == undefined ? { ...initialData.resume.portfolio } : portfolio;
    const alllinks = Object.values(links.set)
    const [opensocial, setSocialBox] = useState(migrated || Object.keys(links.set).length >= 1 &&  (alllinks[0].link.length || alllinks[0].label.length));
    const _ = require('lodash');
    const addMoreBlockHandler = (data) => {
        let id = 'id_' + Math.floor(Math.random() * 1000);
        //Only add available options
        let ob = { ...links.set, [id]: { label: '', link: '' } }
        savePortfolio(ob)
    }
    const saveAction = (data) => {
        let ob = { ...links.set, ...data }
        savePortfolio(ob)
    }
    const deleteAction = id => {
        let ob = { ...links.set }
        ob = _.omit(ob, [id])
        //close if last
        if (!Object.keys(ob).length) setSocialBox(true)
        savePortfolio(ob)
    }

    return (
        <div className="social-link-wrapper">
            <div className="social-link-toggle">
                <button
                    className="btn btn-link btn-icon"
                    type="button"
                    onClick={()=>setSocialBox(!opensocial)}>
                    <i className="icon-plus-minus" style={{display:"flex"}}>{opensocial ? <MinusIcon /> : <PlusIcon />}</i> Add Social Links
                </button>
            </div>

            {opensocial ? <>
                {Object.keys(links.set).map((id, index) => {
                    return (<Link
                        data={links.set[id]} key={index}
                        id={id}
                        saveAction={saveAction} 
                        deleteAction={deleteAction} 
                        validatatorObj={props.validatatorObj}
                        validatorsSet2={props.validatorsSet2}
                        error={props.error}
                        setError={props.setError}
                    />)
                }
                )}

                <div className="add-more-wrap">
                    <button
                        className="add-more"
                        onClick={(e) => { addMoreBlockHandler(); gaTrack('RT App', `Editor: Heading`, 'Add One More'); ga4Track('app_quick_editor_add_one_more', 'RT App', 'Add One More'); }}>
                           <i className="icon-plus-minus"> <PlusIcon /> </i>
                            {Object.keys(links.set).length ? `Add one more` : `Add`} </button>
                </div>
            </> : ''
            }
        </div>
    );
}

export default Portfolio;